// extracted by mini-css-extract-plugin
export default {"preview-text-content":"PreviewTextContent_preview-text-content__5bDTa","scrollable":"PreviewTextContent_scrollable__5HB8Q","title":"PreviewTextContent_title__6BSqm"};